module.exports = __webpack_public_path__ + "img/a4.4fc722f3.jpg";